import * as yup from 'yup';
import { getEnterValidTextMessage, getMaxCharactersTextMessage, getMinCharactersTextMessage, getRequiredTextMessage } from '../../';
import { YRequiredPhoneValidate } from '../../yupValidators';
export const createAccountValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  termsAndConditions: true,
  companyName: '',
  postalAddress: '',
  website: '',
  propertyManagementSoftware: '',
  specifySoftware: undefined,
  unitsProjected: ''
};
export const createAccountSchema = yup.object({
  firstName: yup.string().trim().min(2, getMinCharactersTextMessage('general.first_name', 2)).max(50, getMaxCharactersTextMessage('general.first_name', 50)).required(getRequiredTextMessage('general.first_name')),
  lastName: yup.string().trim().min(2, getMinCharactersTextMessage('general.last_name', 2)).max(50, getMaxCharactersTextMessage('general.last_name', 50)).required(getRequiredTextMessage('general.last_name')),
  email: yup.string().trim().email(getEnterValidTextMessage('general.email_address')).required(getRequiredTextMessage('general.email_address')),
  phone: YRequiredPhoneValidate,
  companyName: yup.string().min(2, 'errors.min').required('errors.required'),
  postalAddress: yup.string().min(2, 'errors.min').required('errors.required'),
  website: yup.string().notRequired(),
  propertyManagementSoftware: yup.string().min(2, 'errors.min').notRequired(),
  unitsProjected: yup.number().positive('errors.only_positive_number').truncate().notRequired()
});